var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66699 0.833984C7.12723 0.833984 7.50033 1.20708 7.50033 1.66732V2.50065H12.5003V1.66732C12.5003 1.20708 12.8734 0.833984 13.3337 0.833984C13.7939 0.833984 14.167 1.20708 14.167 1.66732V2.50065H15.0003C16.8413 2.50065 18.3337 3.99304 18.3337 5.83398V15.0007C18.3337 16.8416 16.8413 18.334 15.0003 18.334H5.00033C3.15938 18.334 1.66699 16.8416 1.66699 15.0007V5.83398C1.66699 3.99304 3.15938 2.50065 5.00033 2.50065H5.83366V1.66732C5.83366 1.20708 6.20676 0.833984 6.66699 0.833984ZM12.5003 4.16732C12.5003 4.62755 12.8734 5.00065 13.3337 5.00065C13.7939 5.00065 14.167 4.62755 14.167 4.16732H15.0003C15.9208 4.16732 16.667 4.91351 16.667 5.83398V6.25065H3.33366V5.83398C3.33366 4.91351 4.07985 4.16732 5.00033 4.16732H5.83366C5.83366 4.62755 6.20676 5.00065 6.66699 5.00065C7.12723 5.00065 7.50033 4.62755 7.50033 4.16732H12.5003ZM16.667 7.91732H3.33366V15.0007C3.33366 15.9211 4.07985 16.6673 5.00033 16.6673H15.0003C15.9208 16.6673 16.667 15.9211 16.667 15.0007V7.91732Z",
    fill: "#2686C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarActive);
export default __webpack_public_path__ + "static/media/calendar-active.cd231446ed9437b1b1a91e549a707f5d.svg";
export { ForwardRef as ReactComponent };